import React, {
  useEffect,
  useState,
} from 'react';
import {
  TextField, Button, CardContent, CardHeader, FormControlLabel, Switch, Select, MenuItem, FormControl, InputLabel,
} from '@material-ui/core';
import {
  Props,
} from './types';
import { ColorPalette } from '../../widgets/TitleWidget/types';
import styles from './styles.module.scss';

const HomePointsWidgetCard: React.FC<Props> = (props: Props) => {
  useEffect(() => {
    props.handleChangeData('textColor', ColorPalette.primary)
  },[])
  return (
    (
      <>
        <CardContent>
          <TextField
            value={props.focusedWidgetData.params.title || ''}
            onChange={(event) => props.handleChangeData('title', event.target.value)}
            autoFocus
            margin="dense"
            id="widgetTitle"
            label="Widget Title"
            fullWidth
          />

          <TextField
            value={props.focusedWidgetData.params.pointsSpan || ''}
            onChange={(event) => props.handleChangeData('pointsSpan', event.target.value)}
            autoFocus
            margin="dense"
            id="Widget poitns span"
            label="Widget points span"
            fullWidth
          />


        </CardContent>
      </>
    )
  );
};

export default HomePointsWidgetCard;

